import { useFormContext, useWatch } from 'react-hook-form';
import { SwitchController } from 'controllers/switch-controller';
import { SEAT_TIER_KEYS } from '../utils';
import { Grid, Typography } from '@mui/material';

import { PlanFeaturesFields } from '../plan-features-fields';
import { PlanCatalogPricingNotice } from '../plan-catalog-pricing-notice';

import { OutlinedInputController } from 'controllers/outlined-input-controller';
import { SelectController } from 'controllers/select-controller';
import { NumericFormatInputController } from 'controllers/numeric-format-input-controller';

import { recurringFields } from 'pages/plans/utils';
import { amoutInputConfig } from './utils';

import { planModalBodyStyles } from './styles';

interface IProps {
  isEditMode?: boolean;
}

export const PlanModalBody = ({ isEditMode = false }: IProps) => {
  const { control } = useFormContext();
  const useSeatTiers = useWatch({ control, name: 'useSeatTiers' });
  return (
    <Grid sx={planModalBodyStyles.container}>
      <OutlinedInputController
        withError
        name="name"
        label="Plan Name"
        defaultValue=""
        fullWidth
        placeholder="Plan Name"
      />
      <OutlinedInputController
        withError={!isEditMode}
        disabled={isEditMode}
        name="externalProductId"
        label="PayKickstart Product ID"
        fullWidth
        placeholder="PayKickstart Product ID"
      />
      <Grid sx={planModalBodyStyles.amountContainer}>
        <NumericFormatInputController
          withError
          allowNegative={false}
          fullWidth
          type="tel"
          label="# of Projects"
          name="ofProjects"
          placeholder="Leave empty for unlimited"
        />
        <NumericFormatInputController
          withError
          allowNegative={false}
          fullWidth
          type="tel"
          label="# of Users"
          name="ofUsers"
          placeholder="Leave empty for unlimited"
        />
      </Grid>
      <NumericFormatInputController
        withError
        allowNegative={false}
        fullWidth
        type="tel"
        label="Storage Limit (GB)"
        name="storageLimit"
        placeholder="Leave empty for unlimited"
      />
      <Grid container alignItems="center" gap={1}>
        <SwitchController name="useSeatTiers" />
        <Typography>Use limits for each Lite pricing tier</Typography>
      </Grid>
      {useSeatTiers &&
        SEAT_TIER_KEYS.map((key) => (
          <Grid key={key} container gap={1}>
            <Typography>{key} active users</Typography>
            <NumericFormatInputController
              name={`seatTiers.${key}.maxUsersAmount`}
              label="User limit"
              allowNegative={false}
              decimalScale={0}
              placeholder="Unlimited"
              withError
            />
            <NumericFormatInputController
              name={`seatTiers.${key}.maxProjectsAmount`}
              label="Project limit"
              allowNegative={false}
              decimalScale={0}
              placeholder="Unlimited"
              withError
            />
            <NumericFormatInputController
              name={`seatTiers.${key}.storageLimit`}
              label="Storage limit (GB)"
              allowNegative={false}
              placeholder="Unlimited"
              withError
            />
          </Grid>
        ))}
      <PlanCatalogPricingNotice />
      <Grid sx={planModalBodyStyles.amountContainer}>
        <NumericFormatInputController {...amoutInputConfig} label="Display Amount" name="amount" />
        <SelectController
          withError
          label="Billing Period"
          name="recurring"
          placeholder="Billing Period"
          options={recurringFields}
          defaultValue="MONTHLY"
        />
      </Grid>
      <NumericFormatInputController
        withError
        allowNegative={false}
        decimalScale={0}
        fullWidth
        type="tel"
        label="Trial Days"
        name="trialDays"
        placeholder="0"
      />
      <PlanFeaturesFields />
      <Typography sx={planModalBodyStyles.helperText}>
        Empty project, user, or storage limits mean unlimited.
      </Typography>
    </Grid>
  );
};
